import React from 'react'
import ProposalTab from './ProposalTab'

const ProposalService = ({type}) => {
  return (
    <div><ProposalTab isIndustry={false} type={type}/></div>
  )
}

export default ProposalService